import React from 'react'
import { compose } from 'recompose'
import { lpForm } from 'lp-form'
import { Field, propTypes as formPropTypes } from 'redux-form'
import { SubmitButton } from 'lp-components'
import { ToggleCheckbox, SectionBlock, SectionHeader } from 'components'
import PropTypes from 'prop-types'
import * as Types from 'types'
import { camelCase } from 'lodash'

const propTypes = {
  ...formPropTypes,
  badges: PropTypes.arrayOf(Types.badge),
  title: PropTypes.string,
  hideSubmit: PropTypes.bool,
  bare: PropTypes.bool,
}

const defaultProps = {
  badges: [],
  title: 'Badges',
  hideSubmit: false,
  bare: false,
}

function PortalBadgeForm({
  handleSubmit,
  submitSucceeded,
  pristine,
  submitting,
  badges,
  title,
  hideSubmit,
  bare,
}) {
  const visibleBadges = (badges || []).filter(
    (badge) => badge.visibleInUserPortal
  )

  if (visibleBadges.length === 0) return null

  const Container = bare ? React.Fragment : SectionBlock

  return (
    <Container>
      {bare ? (
        <h2>{title}</h2>
      ) : (
        <SectionHeader>
          <h2>{title}</h2>
        </SectionHeader>
      )}
      <form onSubmit={handleSubmit} noValidate>
        <div className="badge-questions-section">
          {visibleBadges.map((badge) => (
            <div key={`badge-${badge.id || badge.name}`}>
              <label htmlFor={`badge-toggle-${badge.name}`}>
                {badge.questionText}
              </label>
              <Field
                id={`badge-toggle-${badge.name}`}
                name={camelCase(badge.name)}
                component={ToggleCheckbox}
                label={false}
                className="toggle-checkbox"
              />
            </div>
          ))}
        </div>
        {!hideSubmit && (
          <div className="button-wrapper">
            <SubmitButton
              {...{ pristine: submitSucceeded && pristine, submitting }}
            >
              Save Response
            </SubmitButton>
          </div>
        )}
      </form>
    </Container>
  )
}

PortalBadgeForm.propTypes = propTypes
PortalBadgeForm.defaultProps = defaultProps

export default compose(
  lpForm({
    name: 'portal-badges',
    enableReinitialize: true,
  })
)(PortalBadgeForm)
